export const VIEW_ENGINE_URL = '/ViewEngine'
